import React, { useEffect, useState } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import ProductDetailsComponent from "../../components/ProductDetails/ProductDetails";
import RelatedProducts from "../../components/ProductDetails/relatedProducts";
import { productsData } from "../../data/homeProducts";
import UseGeneral from "../../hooks/useGeneral";
import "./style.css";
import { BASE_URL } from "../../Axios/base_url";
import { Axios } from "../../Axios";
import { ThreeCircles, ThreeDots } from "react-loader-spinner";
import ContentLoader from "react-content-loader";
import { useSelector } from "react-redux";
const ProductDetailsLayout = () => {
  const localData = localStorage.getItem("green_trees");
  const userId = localData && JSON.parse(localData);
  const { language } = UseGeneral();
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [searchParams] = useSearchParams();
  const [data, setData] = useState({});
  const [relatedPRoductsArr,setRelatedProducts]=useState([]);
  const offlineCart = useSelector((state) => state.offlineCart);
  
  const getData = () => {
    setLoading(true);
    Axios({
      url: BASE_URL + `products/get_product_by_id/${searchParams?.get("id")}`,
      method: "POST",
      data: { id: userId },
    })
      .then((res) => {
        let pushedItem={...res?.result};
        let relatedRes=[...res?.result?.related_products];
        let pushedRelated=[];
        for(let i=0;i<relatedRes.length;i++){
          for(let k=0;k<offlineCart.items.length;k++){
            if(offlineCart.items[k].id==relatedRes[i].id){
              relatedRes[i].in_cart=1;
              relatedRes[i].quantity=offlineCart?.items[k].quantity
            }
          }
          pushedRelated.push(relatedRes[i])
        }
        setRelatedProducts(pushedRelated)
        for(let i=0;i<offlineCart.items.length;i++){
          if(offlineCart.items[i].id==pushedItem.id){
            pushedItem.in_cart=1;
            pushedItem.quantity=offlineCart?.items[i].quantity
          }
        }
        setData(pushedItem);

      })
      .finally(() => {
        setLoading(false);
      });
  };
  useEffect(() => {
    getData();
  }, [searchParams?.get("id")]);
  return (
    <div className="rowDiv CartProducts product_details">
      <div className="rowSpaceBetween">
        <div className="rowDiv HomeProducts">
          {loading ? (
            <ThreeDots />
          ) : (
            data && (
              <ProductDetailsComponent
                getItmData={getData}
                item={data}
                id={searchParams?.get("id")}
                image={
                  data?.imagesdata?.images?.length > 0 && data?.images[0]?.url
                }
                images={data?.images}
                title={data.title && data?.title[language]}
                price={data?.price}
              />
            )
          )}
        </div>
      </div>
      <RelatedProducts getData={getData} products={relatedPRoductsArr} />
    </div>
  );
};

export default ProductDetailsLayout;
